const messages = {
  title: "Marketinška soglasja",
  required: "Obvezno",
  answered: "✓ Odgovorjeno",
  read: "Prebrano",
  notRead: "Ni prebrano",
  alreadyAnswered: "Že odgovorjeno",
  requiredQuestionsMustBeAccepted:
    "Še {count} obveznih vprašanj je treba sprejeti",
  pleaseAnswerQuestions: "Prosimo, odgovorite na naslednja vprašanja:",
  iAccept: "Sprejemam",
  scrollToUnlock: "Za odklepanje se pomaknite do konca",
  fieldRequired: "To polje je obvezno",
  scrollToContinue: "↓ Za nadaljevanje se pomaknite do konca",
  saving: "Shranjevanje...",
  saveConsents: "Shrani soglasja",
  allRequiredAccepted: "✓ Vsa obvezna vprašanja sprejeta",
  requiredConsentsCompleted:
    "{completed}/{total} obveznih soglasij izpolnjenih",
  selectConsentToView:
    "Izberite soglasje s seznama za ogled vsebine",
  readAllContentFirst: "Najprej preberite celotno vsebino: {names}",
  acceptAllRequiredIn:
    "Sprejmite vsa obvezna vprašanja v: {names}",
  acceptAllBeforeSaving:
    "Pred shranjevanjem sprejmite vsa obvezna vprašanja.",
  failedToSave: "Soglasij ni bilo mogoče shraniti. Poskusite znova.",
  errorSaving:
    "Pri shranjevanju soglasij je prišlo do napake. Poskusite znova.",
  failedToLoad: "Soglasij ni bilo mogoče naložiti. Osvežite stran.",
  viewPdf: "Prikaži PDF",
  requiredConsentTitle: "Obvezno soglasje",
  acceptAndContinue: "Sprejmi in nadaljuj",
};

export default {
  messages,
};
